import { useParams } from "react-router-dom";
import CompanyPropertiesPanel from "@/components/CompanyPropertiesPanel/CompanyPropertiesPanel";

function CompanyPropertiesTab() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return null;
  }

  return (
    <CompanyPropertiesPanel
      companyId={id}
      addLinkTo={`/companies/${id}/properties/new`}
    />
  );
}

export default CompanyPropertiesTab;
